import { useEffect, useMemo, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"

import {
  getMessageTemplates,
  useEditMessageTemplateMutation,
  useLazyGetMessageTemplatesQuery,
} from "store/api/contractorsApi"
import { useAppSelector } from "store/hooks"
import { ApiTypes, UITypes } from "types"

import getErrorMessage from "utils/getErrorMessage"
import { MessageForm } from "components/form/MessageForm"

export const MessageTemplateEdit = () => {
  const [triggerEditMessageTemplate, { isLoading }] = useEditMessageTemplateMutation()
  const [triggerGetMessageTemplates] = useLazyGetMessageTemplatesQuery()
  const [currentTemplate, setCurrentTemplate] = useState<ApiTypes.Model.MessageTemplate | null>(null)
  const [searchParams] = useSearchParams()
  const templateId = searchParams.get("id")
  const selecttMessageTemplates = useMemo(() => getMessageTemplates.select(), [])
  const messageTemplates = useAppSelector(selecttMessageTemplates)
  const navigate = useNavigate()

  const trasformEditData = useMemo((): UITypes.MessageTemplate | undefined => {
    if (!currentTemplate) return undefined

    return {
      title: currentTemplate.title,
      message: currentTemplate.content_plain,
      message_rich: currentTemplate.content_rich,
      frequency: currentTemplate.repeat_period,
    }
  }, [currentTemplate])

  const onSetCurrentTemplate = () => {
    const templatesList = messageTemplates?.data?.data
    if (!templateId || !templatesList?.length) {
      setCurrentTemplate(null)
    } else {
      const currentTemplate = templatesList.filter(item => item.id === Number(templateId))[0]
      setCurrentTemplate(currentTemplate)
    }
  }

  const onEditTemplate = async (data: UITypes.MessageTemplate) => {
    try {
      const res = await triggerEditMessageTemplate({
        body: {
          title: data.title,
          content_plain: data.message,
          content_rich: data.message_rich || "",
          repeat_period: data.frequency as ApiTypes.Model.MessageTemplateFrequency,
          version: currentTemplate?.version,
        },
        id: templateId!,
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
        return false
      } else {
        toast.success("Message template has been successfully updated!")
        navigate("/messages/create-template")
        triggerGetMessageTemplates()
      }
    } catch (error) {
      console.error(error)
      return false
    }
  }

  useEffect(() => {
    onSetCurrentTemplate()
  }, [messageTemplates, templateId])

  return <MessageForm isLoading={isLoading} onSave={onEditTemplate} editableTemplate={trasformEditData} />
}
